import MenuIcon from '@mui/icons-material/Menu';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import IconButton from '@mui/material/IconButton';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import { startTransition, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { Page } from '@src/interfaces/misc';
import { useLocale } from '../../i18n/LocaleContext';

interface NavigationProps {
  pages: Page[];
}

const Navigation = ({ pages }: NavigationProps) => {
  const { t } = useLocale();
  const navigate = useNavigate();
  const { pathname } = useLocation();
  const isCurrentPage = (path: string) => pathname.replace(/\/$/, '') === path.replace(/\/$/, '');
  const [anchorElement, setAnchorElement] = useState<HTMLElement | null>(null);
  const menuOpen = Boolean(anchorElement);

  const navigateTo = (path: string) => {
    setAnchorElement(null);
    startTransition(() => navigate(path));
  };

  return (
    <>
      <Box sx={{ flexGrow: 1, display: { xs: 'flex', md: 'none' } }}>
        <IconButton
          color="inherit"
          aria-label={t('navigation.openMenu')}
          aria-controls={menuOpen ? 'mobile-navigation' : undefined}
          aria-expanded={menuOpen ? 'true' : undefined}
          aria-haspopup="menu"
          onClick={(event) => setAnchorElement(event.currentTarget)}
        >
          <MenuIcon />
        </IconButton>
        <Menu
          id="mobile-navigation"
          variant="menu"
          anchorEl={anchorElement}
          open={menuOpen}
          onClose={() => setAnchorElement(null)}
          MenuListProps={{ 'aria-label': t('navigation.mobileMenu') }}
        >
          {pages.map((page) => (
            <MenuItem
              key={page.path}
              selected={isCurrentPage(page.path)}
              aria-current={isCurrentPage(page.path) ? 'page' : undefined}
              onClick={() => navigateTo(page.path)}
            >
              {page.title}
            </MenuItem>
          ))}
        </Menu>
      </Box>
      <Box component="nav" sx={{ flexGrow: 1, gap: 0.5, display: { xs: 'none', md: 'flex' } }}>
        {pages.map((page) => (
          <Button
            key={page.title}
            onClick={() => navigateTo(page.path)}
            aria-current={isCurrentPage(page.path) ? 'page' : undefined}
            sx={{
              my: 1,
              px: 2,
              py: 1,
              color: 'white',
              bgcolor: isCurrentPage(page.path) ? 'rgba(255,255,255,0.14)' : 'transparent',
              '&:hover': { bgcolor: 'rgba(255,255,255,0.2)' },
            }}
          >
            {page.title}
          </Button>
        ))}
      </Box>
    </>
  );
};

export default Navigation;
